<ng-container *ngIf="!isUserSubscribed">
  <section class="container">
  </section>
</ng-container>
<section class="container-fluid mt-5">
  <h2 class="mb-4">Manage your emails notifications</h2> 
  <div *ngIf="!isUserSubscribed" class="my-5 py-4 border border-info">
    <h4 class="text-center">You have been unsubscribed from Zint Grow emails.</h4>
    <p class="text-center">If you wish to resubscribe, please set your preferences and update below.</p>
  </div> 
  <div class="row mx-2 mx-lg-5 px-lg-5">
    <div class="col-12 row mb-1">
      <p class="col-md-8 col-lg-10 mb-1 mb-md-2">Select the <span class="fw-bold">lowest importance score</span> for the notifications to trigger sending you emails.</p>
      <div class="col-md-4 col-lg-2 ms-2 ms-md-0 px-0">
        <select class="form-select rounded-0" [(ngModel)]="selectedImportanceThreshold" >
          <option *ngFor="let threshold of [1,2,3,4,5]">{{threshold}}</option>
        </select>
      </div>
    </div>
    <div class="col-12 row mb-2">
      <p class="col-md-8 col-lg-10 mb-1 mb-md-2">Select <span class="fw-bold">how often</span> you would like to receive emails.</p>
      <div class="col-md-4 col-lg-2 ms-2 ms-md-0 px-0">
        <select class="form-select rounded-0" [(ngModel)]="selectedFrequency">
          <option value="Daily">Daily</option>
          <option value="Weekly">Weekly</option>
        </select>
      </div>
    </div>
    <div class="col-12 row">
    <button class="col-2 col-md-1 ms-auto basic-button-base button-dark" (click)="updateSettings()">Update</button>
    </div>
  </div>
  <div *ngIf="isUserSubscribed" class="mt-5">
    <p class="text-center"><a href="#confirmUnsubscribeModal" data-bs-toggle="modal" data-bs-target="#confirmUnsubscribeModal">Unsubscribe</a> from all Zint Grow emails!</p>
  </div>
</section>

<div class="modal fade" id="confirmUnsubscribeModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Are you sure you wish to unsubscribe?</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p class="text-danger text-center">You will no longer receive any emails from Zint Grow! <br> You still wish to unsubscribe?</p>
              <div class="d-flex justify-content-center mb-4">
                <button class="basic-button-base button-purple" data-bs-dismiss="modal">No</button>
                <button class="basic-button-base button-bear ms-2" data-bs-dismiss="modal" (click)="confirmUnsubscribe()">Yes</button>
              </div>              
            </div>
            <div class="modal-footer">
                <button type="button" class="basic-button-base button-dark" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>